module.exports = __webpack_public_path__ + "static/media/use28.45838936.png";